export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 7a1 1 0 011 1v13a1 1 0 01-1 1H9a1 1 0 01-1-1V8l.005-.103A1 1 0 019 7h11zM10 20h9V9h-9v11z\" fill=\"#7B61FF\"/><path d=\"M16 4H5v13H3V3a1 1 0 011-1h12v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};